import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Moonstone Estate</h3>
            <p>Premium real estate development in Port Harcourt for modern living and smart investments.</p>
            <p>A development of <strong>GTEXT LAND</strong></p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#estates">Our Estate</a></li>
              <li><a href="#contact">Contact Us</a></li>
              {/* <li><a href="/admin">Admin Panel</a></li> */}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Website: <a href="https://www.gtextland.com" target="_blank" rel="noopener noreferrer">www.gtextland.com</a></p>
            <p>Follow us: <a href="https://www.instagram.com/GTEXTLAND/" target="_blank" rel="noopener noreferrer">@GTEXTLAND</a></p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Moonstone Estate Port Harcourt. All rights reserved. A development of GTEXT LAND.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

